export const HEADER_HEIGHT = 65;

export const METADATA_HEIGHT = 80;

export const EMAIL_MAX_LEN = 255;

export const LOGIN_REDIRECT_URL = '/';

export const PUBLIC_ENDPOINT = '/graphql/public';

export const REGISTER_ENDPOINT = '/graphql/public/register';

export const LOGIN_ENDPOINT = '/graphql/public/login';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const FORCE_EXTERNAL =
  window.location.host === 'cloud.digitalocean.com' &&
  !window.location.pathname.startsWith('/registration-next');

export const APOLLO_CLIENT_NAME = 'registration-next';

export const APOLLO_CLIENT_VERSION = '1.0';

export const NETWORK_ERROR_CODE = 403;

export const CF_RAY_ID_REGEXP = /(Cloudflare Ray ID: (<strong>)?)([a-z|0-9]*)(<\/strong>)?/;

export const APP_PLATFORM_TEMPLATE_COOKIE =
  '_digitalocean_app_platform_url_after_activation';

export const CHURN_SURVEY_URL =
  'https://digitalocean.getfeedback.com/r/jgkIoAt5';
